<script>
export default {
  name: 'SkeletonLoader',

  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'circle', 'rect', 'card'].includes(value),
    },
    width: {
      type: [String, Number],
      default: '100%',
    },
    height: {
      type: [String, Number],
      default: '16px',
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    animation: {
      type: String,
      default: 'shimmer',
      validator: value => ['shimmer', 'pulse', 'none'].includes(value),
    },
  },

  computed: {
    skeletonStyle () {
      const width = typeof this.width === 'number' ? `${this.width}px` : this.width
      const height = typeof this.height === 'number' ? `${this.height}px` : this.height

      return {
        width,
        height,
        borderRadius: this.rounded ? '4px' : this.type === 'circle' ? '50%' : '0',
      }
    },

    skeletonClass () {
      return [
        this.$classes['skeleton'],
        this.$classes[`skeleton-${this.type}`],
        this.$classes[`animation-${this.animation}`]
      ]
    },
  },
}
</script>

<template>
  <div :class="skeletonClass" :style="skeletonStyle"></div>
</template>

<style module>
.skeleton {
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  display: inline-block;
}

.skeleton-circle {
  border-radius: 50%;
}

.skeleton-rect {
  border-radius: 4px;
}

.skeleton-card {
  border-radius: 8px;
  padding: 16px;
}

.animation-shimmer {
  animation: shimmer 1.5s infinite;
}

.animation-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

.animation-none {
  background: #e0e0e0;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}
</style>
